import { TrackingContext, type TrackingContextValue } from '@ps/web-core-analytics';
import React, { useCallback, useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import Tracker from './Tracker';

const VisibilityTracker: React.FC<{ name: string; trackingContext: TrackingContextValue }> = ({
  name,
  trackingContext,
  children
}) => {
  const [seen, setSeen] = useState(false);

  const onVisibilityChange = useCallback((visible: boolean) => {
    if (visible) {
      setSeen(true);
    }
  }, []);

  return (
    <VisibilitySensor
      intervalDelay={1000}
      minTopValue={50}
      delayedCall
      partialVisibility
      active={!seen}
      onChange={onVisibilityChange}
    >
      <>
        {children}
        <TrackingContext.Provider value={trackingContext}>
          <Tracker seen={seen} name={name} />
        </TrackingContext.Provider>
      </>
    </VisibilitySensor>
  );
};

export default VisibilityTracker;
